// src/store.js
import { createStore } from 'vuex';

export default createStore({
  state: {
    collapsedMenu: JSON.parse(localStorage.getItem('collapsedMenu')) || false,
    auth: {
      // El token vive solo en memoria para evitar exposición vía XSS
      token: null,
      admin: JSON.parse(localStorage.getItem('admin') || 'null'),
    },
  },
  mutations: {
    toggleMenu(state) {
      state.collapsedMenu = !state.collapsedMenu;
      localStorage.setItem('collapsedMenu', JSON.stringify(state.collapsedMenu));
    },
    setAuth(state, { token, admin }) {
      state.auth.token = token;
      state.auth.admin = admin;
      // Solo guardamos datos no sensibles en localStorage para persistir nombre/rol
      localStorage.setItem('admin', JSON.stringify(admin));
      localStorage.setItem('rolUsuario', admin.role);
      localStorage.setItem('nombreUsuario', `${admin.first_name} ${admin.last_name}`);
    },
    clearAuth(state) {
      state.auth.token = null;
      state.auth.admin = null;
      localStorage.removeItem('admin');
      localStorage.removeItem('rolUsuario');
      localStorage.removeItem('nombreUsuario');
      localStorage.removeItem('usuario');
    },
  },
});
